import { useEffect, useState, type ReactNode } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

import { useAuth } from "../lib/auth";
import { onUnread } from "../lib/notify";
import { Avatar } from "./AppIcon";
import { Icon, Logo } from "./Icon";
import { UpdateBanner } from "./UpdateBanner";

const TABS = [
  { to: "/", label: "Space", icon: "space", end: true },
  { to: "/marketplace", label: "Marketplace", icon: "marketplace" },
  { to: "/people", label: "People", icon: "people" },
  { to: "/profile", label: "Profile", icon: "profile" },
];

export function Layout() {
  return (
    <div className="layout">
      <Outlet />
      <UpdateBanner />
      <nav className="tabbar" aria-label="Main">
        <div className="tabbar-inner">
          {TABS.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} className={({ isActive }) => `tab${isActive ? " active" : ""}`}>
              <Icon name={t.icon} />
              <span>{t.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}

/** The shell's page header: mark, title, actions, and the avatar. */
export function TopBar({ title, children, back, avatar = true }: { title: string; children?: ReactNode; back?: ReactNode; avatar?: boolean }) {
  const { user } = useAuth();
  return (
    <header className="topbar">
      <div className="topbar-row">
        {back ?? <Logo />}
        <h1>{title}</h1>
        {children}
        {avatar && user && <Bell />}
        {avatar && user && (
          <Link to="/profile" className="avatar-btn" aria-label="Your profile">
            <Avatar name={user.display_name} url={user.avatar_url} size={34} />
          </Link>
        )}
      </div>
    </header>
  );
}

/** ADR-0031: the inbox, with the number of unread notifications. */
function Bell() {
  const [count, setCount] = useState(0);
  useEffect(() => onUnread(setCount), []);
  const label = count ? `Notifications, ${count} unread` : "Notifications";
  return (
    <Link to="/notifications" className="icon-btn bell-btn" aria-label={label} title="Notifications">
      <Icon name="bell" />
      {count > 0 && <span className="badge" aria-hidden>{count > 99 ? "99+" : count}</span>}
    </Link>
  );
}

export function Page({ children, noTabs }: { children: ReactNode; noTabs?: boolean }) {
  return <main className={`page${noTabs ? " no-tabs" : ""}`}>{children}</main>;
}
